import { render, staticRenderFns } from "./LmInvoice.vue?vue&type=template&id=04a4e695&"
import script from "./LmInvoice.vue?vue&type=script&lang=js&"
export * from "./LmInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports